/* =========================
   🧠 等待 Google Maps 加载
========================= */
function waitForGoogle(callback) {
  if (window.google && window.google.maps) {
    callback();
  } else {
    setTimeout(() => waitForGoogle(callback), 100);
  }
}

if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template")?.content?.firstElementChild?.cloneNode(
            true,
          );

        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        this.geocoder = null;

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;

        if (!rootUrl.endsWith("/")) {
          rootUrl += "/";
        }

        const url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");

            this.renderPreview(html);
          })
          .catch(() => {
            const btn = this.querySelector("button");

            if (btn) {
              btn.removeEventListener("click", this.onClickRefreshList);
            }

            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";

        if (this.errorHtml) {
          this.appendChild(this.errorHtml);
        }

        this.querySelector("button")?.addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const oldDrawer = document.querySelector("pickup-availability-drawer");

        if (oldDrawer) {
          oldDrawer.remove();
        }

        const preview = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        );

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = preview.outerHTML;

        this.setAttribute("available", "");

        const newDrawer = sectionInnerHTML.querySelector(
          "pickup-availability-drawer",
        );

        document.body.appendChild(newDrawer);

        const button = this.querySelector("button");

        if (button) {
          button.addEventListener("click", (evt) => {
            newDrawer.show(evt.target);

            setTimeout(() => {
              this.initPickupSearch();
              this.autoLocate();
            }, 0);
          });
        }

        this.updatePickupText();
      }

      /* =========================
         🔍 搜索逻辑
      ========================= */
      initPickupSearch() {
        setTimeout(() => {
          const input = document.getElementById("pickup-search-input");

          const btn = document.getElementById("pickup-search-btn");

          const listEl = document.querySelector(".pickup-availability-list");

          if (!input || !btn || !listEl) return;

          // 清空恢复默认排序
          if (!input.dataset.binded) {
            input.dataset.binded = "true";

            input.addEventListener("input", () => {
              if (!input.value.trim()) {
                this.restoreOriginalList();
              }
            });
          }

          // 防重复绑定
          if (btn.dataset.binded) return;

          btn.dataset.binded = "true";

          waitForGoogle(async () => {
            if (!this.geocoder) {
              this.geocoder = new google.maps.Geocoder();
            }

            btn.addEventListener("click", async () => {
              const address = input.value.trim();

              if (!address) {
                this.restoreOriginalList();
                return;
              }

              try {
                const { lat, lng } = await this.geocodeAddress(address);

                const nearbyOutlets = await this.fetchNearbyOutlets({
                  sku: this.dataset.sku,
                  quantity: 1,
                  lat,
                  lon: lng,
                  count: 5,
                });

                this.sortStoreList(nearbyOutlets, listEl);
              } catch (err) {
                console.error(err);
              }
            });
          });
        }, 300);

        this.bindStoreRadio();
        this.restoreSelectedStore();
      }

      /* =========================
         📦 排序门店
      ========================= */
      sortStoreList(nearbyOutlets, listEl) {
        console.log(nearbyOutlets);
        console.log(listEl);
        const shopifyLis = Array.from(
          listEl.querySelectorAll(
            ".pickup-availability-list__item[data-store-name]",
          ),
        );

        // 保存原始列表
        if (!listEl.dataset.originalHtml) {
          listEl.dataset.originalHtml = listEl.innerHTML;
        }

        // 去重
        const uniqueMap = new Map();

        shopifyLis.forEach((li) => {
          const name = li.dataset.storeName.trim();

          if (!uniqueMap.has(name)) {
            uniqueMap.set(name, li);
          }
        });

        const uniqueLis = Array.from(uniqueMap.values());

        const matchedLis = [];

        const unmatchedLis = [...uniqueLis];

        nearbyOutlets.forEach((outlet) => {
          const outletName = outlet.outlet_title.trim();

          const index = unmatchedLis.findIndex((li) => {
            return li.dataset.storeName.trim() === outletName;
          });

          if (index > -1) {
            matchedLis.push(unmatchedLis[index]);

            unmatchedLis.splice(index, 1);
          }
        });

        const finalLis = [...matchedLis, ...unmatchedLis];

        listEl.innerHTML = finalLis.map((li) => li.outerHTML).join("");

        this.restoreSelectedStore();
      }

      /* =========================
         ♻️ 恢复原始列表
      ========================= */
      restoreOriginalList() {
        const listEl = document.querySelector(".pickup-availability-list");

        if (listEl && listEl.dataset.originalHtml) {
          listEl.innerHTML = listEl.dataset.originalHtml;

          this.restoreSelectedStore();
        }
      }

      bindStoreRadio() {
        const listEl = document.querySelector(".pickup-availability-list");

        if (!listEl || listEl.dataset.radioBinded) {
          return;
        }

        listEl.dataset.radioBinded = "true";

        listEl.addEventListener("change", (e) => {
          const input = e.target.closest(".select-store-input");

          if (!input) return;

          const storeData = {
            name: input.value,
            pickuptime: input.dataset.pickuptime,
          };

          localStorage.setItem("selectedStore", JSON.stringify(storeData));

          this.updatePickupText();

          document.querySelector("pickup-availability-drawer")?.hide();
        });
      }

      restoreSelectedStore() {
        const saved = localStorage.getItem("selectedStore");

        if (!saved) return;

        const data = JSON.parse(saved);

        const inputs = document.querySelectorAll(".select-store-input");

        inputs.forEach((input) => {
          if (input.value === data.name) {
            input.checked = true;
          }
        });
      }

      /* =========================
         📍 地址转经纬度
      ========================= */
      geocodeAddress(address) {
        return new Promise((resolve, reject) => {
          this.geocoder.geocode({ address }, (results, status) => {
            if (status !== "OK") {
              reject(status);
              return;
            }

            const loc = results[0].geometry.location;

            resolve({
              lat: loc.lat(),
              lng: loc.lng(),
            });
          });
        });
      }

      /* =========================
         📡 调接口
      ========================= */
      async fetchNearbyOutlets(params) {
        const { sku, quantity = 1, lat, lon, count = 5 } = params;

        try {
          const res = await fetch(
            "https://shopify-big.bigcaring.com.my/api/outlet/available",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                sku,
                quantity,
                lat,
                lon,
                count,
              }),
            },
          );

          const data = await res.json();

          console.log("接口数据", data);

          return data.available || [];
        } catch (err) {
          console.error(err);
          return [];
        }
      }

      /* =========================
         📍 自动定位
      ========================= */
      async autoLocate() {
        try {
          const pos = await this.getUserLocation();

          const listEl = document.querySelector(".pickup-availability-list");

          if (!listEl) return;

          const nearbyOutlets = await this.fetchNearbyOutlets({
            sku: this.dataset.sku,
            lat: pos.latitude,
            lon: pos.longitude,
          });

          this.sortStoreList(nearbyOutlets, listEl);
        } catch (err) {
          console.warn("定位失败", err);
        }
      }

      getUserLocation() {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject();
            return;
          }

          navigator.geolocation.getCurrentPosition((pos) => {
            resolve({
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
            });
          }, reject);
        });
      }

      updatePickupText() {
        const saved = localStorage.getItem("selectedStore");

        const el = document.querySelector(
          ".product__pickup-availabilities .caption-large",
        );

        if (!saved || !el) return;

        try {
          const data = JSON.parse(saved);

          if (data.name) {
            const template = el.dataset.template;

            el.innerHTML = template.replace("[[location]]", data.name);
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
  );
}

/* =========================
   Drawer
========================= */
if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button")?.addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (e) => {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.hide();
          }
        });
      }

      handleBodyClick(evt) {
        if (
          evt.target != this &&
          !evt.target.closest("pickup-availability-drawer")
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");

        document.body.classList.remove("overflow-hidden");
      }

      show() {
        this.setAttribute("open", "");

        document.body.classList.add("overflow-hidden");
      }
    },
  );
}
